import { useEffect, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export default function VerifyMagicLink() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const { verifyMagicLink, athlete } = useAuth()
  const [error, setError] = useState('')
  const [verifying, setVerifying] = useState(true)
  const verificationAttempted = useRef(false)

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setError('Invalid magic link - no token provided')
        setVerifying(false)
        return
      }

      try {
        await verifyMagicLink(token)
        // Navigation will happen via the useEffect that monitors athlete
      } catch (error) {
        if (error instanceof Error) {
          setError(error.message)
        } else {
          setError('Failed to verify magic link')
        }
        setVerifying(false)
      }
    }

    // Only attempt verification once
    if (!verificationAttempted.current && token) {
      verificationAttempted.current = true
      verify()
    }
  }, [token, verifyMagicLink])

  // Redirect when user is authenticated
  useEffect(() => {
    if (athlete) {
      const pendingInvite = localStorage.getItem('pendingMarketerInviteToken')
      if (pendingInvite) {
        localStorage.removeItem('pendingMarketerInviteToken')
        navigate(`/marketer-invite/${pendingInvite}`)
      } else {
        navigate('/')
      }
    }
  }, [athlete, navigate])

  return (
    <div className="flex items-center justify-center min-h-screen relative">
      <div className="fixed inset-0 -z-10 bg-linear-to-br from-[#000000] via-[#0a1e29] to-[#003b4d]"></div>

      <div className="w-full max-w-md px-4">
        <div className="bg-white/10 backdrop-blur-xs border border-white/5 shadow-xl rounded-lg p-6">
          <h2 className="text-2xl font-bold mb-6 text-center text-white">Verifying Magic Link</h2>

          {verifying && !error && (
            <div className="text-center">
              <div className="mb-4">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-[#C0FD72]"></div>
              </div>
              <p className="text-gray-400">Please wait while we verify your magic link...</p>
            </div>
          )}

          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}

          {error && (
            <button
              onClick={() => navigate('/signin')}
              className="w-full bg-[#C0FD72] text-black p-2 rounded hover:bg-[#a8e45a] font-medium"
            >
              Return to Sign In
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
